import React, { Component,Fragment } from 'react';
import { Highlighter, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { connect } from 'react-redux';
import {
	BRANCH_ACCESS
} from '../../../constants/general';
import { fetchAdmins } from '../../../store/actions/adminActions';

class SearchAdmin extends Component {
	
	constructor(props) {
		super(props);
	    this.state = {
			isLoading:false,
			openSearcher:true,
			selected:"",
			admins: [],
            placeholder:'Buscar admins'
		}
		this.props.fetchAdmins()
	}

	componentDidUpdate(prevProps){
		let newList = [];
		let { admins, userHigherAccess } = this.props;
        console.log("componentDidUpdate",admins)
		if ((prevProps.admins  && prevProps.admins.data && prevProps.admins.data.length) !== (admins.data && admins.data.length)) {
            newList = admins.data.map(b => { return { access_id: b.id, related_access: b } })
			newList = newList.concat({access_id:-1,related_access: {id:-1,name:this.state.placeholder}})
            console.log("admins",newList)
			this.setState({ admins: newList })
		}
	}

	SearchAction(query){
		let { userHigherAccess } = this.props;
		this.setState({ isLoading: true })
		if(userHigherAccess > BRANCH_ACCESS){
			this.props.fetchAdmins(1,`name=ilike ${query}`).then(() => {
				this.setState({ isLoading: false })
			})
			.catch((err) => {
				this.setState({ isLoading: false })
			})
		}
	}

	render () {
		return (
			<AsyncTypeahead
				ref={(ref) => this._typeahead = ref}
				className={'iniline-select'}
				labelKey="name"
				options={ this.state.admins.map($0 => $0.related_access)}
				onChange={this.props.change}
				onSearch={(query) => this.SearchAction(query)}
				isLoading={this.state.isLoading}
				value={this.state.selected}
				placeholder={this.state.placeholder} 
				renderMenuItemChildren={
					(option, props, index) => <div className="normaltext-autocomplete" style={{display: `flex`,gap: `10px`}}>
						<img className="avatar_small" 
							src={option.avatar_url} 
							ref={ `avatar_url`}  
							onError={ ()=>this.refs[`avatar_url`].src= 'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png' }
							alt={option.name}/>
						<div style={{width: `calc(100% - 40px)`}}>
							{option.name}<br/>
							<small>{option.email}</small>
						</div>
					</div>
				}/>
		)	
	}
}


const mapStateToProps = (state) => {
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.name,
		company:state.company,
		userHigherAccess: state.userHigherAccess,
		errors: state.errors,
		json_lang: state.json_lang,
		admins:state.admins
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchAdmins: (page,query) => dispatch(fetchAdmins(page,query)), 
	}
}

export default connect(mapStateToProps , mapDispatchToProps)(SearchAdmin);


// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SearchAdmin.js